import React from 'react';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';

import { setTranslation } from '../../redux/actions/translationAction';

export default function TranslationProvider({ children }) {
	const dispatch = useDispatch();

	// Remember translation on App Start without relying on react-i18next hooks
	React.useEffect(() => {
		try {
			i18next.changeLanguage('fr');
		} catch (_) { /* ignore */ }
		dispatch(setTranslation('fr'));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return children;
}
